import { useTranslation } from "react-i18next";
import { Form, Input, message, Modal, Select, Spin, Tooltip, Tree, TreeDataNode, TreeProps, } from "antd";
import "./page-builder.scss";
import "./grapesjs.min.css";
import grapesjs, { Block, Editor, ProjectData } from "grapesjs";
import GjsEditor, { useEditor, WithEditor } from "@grapesjs/react";
import gjsBlocksBasic from "grapesjs-blocks-basic";
import gjsTailWind from "grapesjs-tailwind";
import gjsPresetWeb from "grapesjs-preset-webpage";
import gjsStyleBg from "grapesjs-style-bg";
import gjsStyleFilter from "grapesjs-style-filter";
import gjsStyleGradient from "grapesjs-style-gradient";
import gjsTabs from "grapesjs-tabs";
import gjsFonts from "@silexlabs/grapesjs-fonts";
import grapesjsTyped from "grapesjs-typed";
import baseReactComponent from "./plugins/base-react-component";
import gjsLecturerComponent from "./plugins/lecturer";
import gjsConditionComponent from "./plugins/condition";
import CommonAdvanceSettingsPlugin from "./plugins/common-advance-settings";
import { imagesAssests, styleManagerConfig } from "./grapesjs-config";
import { LoadingOutlined, RetweetOutlined } from "@ant-design/icons";
import { HelpService } from "../../service/helper.service";
import { useParams } from "react-router-dom";
import {
  getReviewCourse,
  getStudentRegisterCourse,
  getTemplateByCourseId,
  getTemplateCategory,
  saveTemplateBlock,
  saveTemplates,
} from "../../service/page-builder/page-builder";
import { PlanInfo } from "../../types/assign-course-construction";
import { IBodyBlock, IBodyTemplates } from "../../types/grapesjs";
import { routesConfig } from "../../config/routes";
import { get, isArray, isEmpty } from "lodash";
import { forwardRef, Key, Ref, useEffect, useImperativeHandle, useRef, useState, } from "react";
import { globalStore, useAuthStore, useCoursesStore } from "../../stores/stores";
import { getAdditionalForTemplate, getCourseDetail, postCourseSearch } from "../../service/course-construct";
import { createRoot } from "react-dom/client";
import {
  affiliatedBlock,
  conditionBlockGenerete,
  contactBlockCustom,
  countBlockGenerete,
  headerBlockLogo,
  headerBlockName,
  nameAffiliatedBlocks,
  nameBasicBlock,
  nameCategoryBlocks,
  nameCategoryTemplates,
  nameConditionBlocks,
  nameContactBlock,
  nameCountBlocks,
  nameHeaderBlocks,
  nameLecturersBlock,
  nameOpinionBlocks,
  nameQuestionBlocks,
  nameRegisterBlocks,
  nameRegisterPolicyBlocks,
  nameRoadMapBlocks,
  opinionBlockCustom,
  questionBlockCustom,
  registerBlock1,
  registerBlock2,
  registerBlock3,
  registerPolicy,
  roadMapBlockGenerete,
  spanBlockCustom,
} from "./grapesjs-ui";
import {
  addBlockToEditor,
  checkTemplateIsNull,
  confirmMessage,
  convertItemToBlock,
  CustomDisplayPros,
  getIdIndexDB,
  isValidJSON,
  loadDefaultUI,
  reloadAllTemplate,
  saveToIndexDB,
  stringCssObj,
} from "./grapesjs-service";
import { extractKeys } from "../../utils/arrays";
import { useDirty } from "../../contexts/DirtyProvider";
import { BASE_URL_V2 } from "../../config/api/configApiv2";
import { useStompClient, useSubscription } from "react-stomp-hooks";
import { getDataGeneral } from "../../service/content-course/contenCourseApi";
import {
  optionsSkills
} from "../../components/course-construction/content-course-construction/setting-content-course/condition-register/constants/data";
import FontSizeConfig from "./plugins/font-size";
import FontFamilyCustomPlugin from "./plugins/font-family";
import { ConnectService } from "../../service/observable/connect";
import { formatCurrencyToVND } from "../../utils/functionUltils";
import { toBase64 } from "../../utils/app";

type Prop = {
  planInfo: PlanInfo;
  detailData: any;
  setIsReadyNextTab: (val: any) => void;
  tab: string;
  mode: string;
};
let saveDraft = false;
declare global {
  interface Window {
    antd: any;
  }
}

interface RefComponentClass {
  updateComponentClass: (value: string) => void;
}

const PageBuilder = ({ planInfo, detailData, setIsReadyNextTab, tab, mode }: Prop) => {
  const { t } = useTranslation();
  const replaceComponentClassRef = useRef<RefComponentClass>(null);
  const { reload } = globalStore();

  const helpService = new HelpService();
  const connectService = new ConnectService();
  const params = useParams();
  const { setDirty } = useDirty();
  const stompClient = useStompClient();
  const [nameBlock, setNameBlock] = useState('');
  const [openModal, setOpenModal] = useState<boolean>(false);
  const [dataTree, setDataTree] = useState([]);
  const [loading, setLoading] = useState(true);
  const [editorCustom, setEditorCustom] = useState<Editor>();
  const [blockUISave, setBlockUISave] = useState<string>('');
  const accessToken = useAuthStore((state) => state.accessToken);
  const [iconVisible, setIconVisible] = useState(false);
  const [isOpenSync, setIsOpenSync] = useState<boolean>(false);
  const [updateTemplateTime, setUpdateTemplateTime] = useState(0);
  const [currentUpdateTemplateTime, setCurrentUpdateTemplateTime] = useState(0);
  const [pageBuilderTemplate, setPageBuilderTemplate] = useState('');
  const [allCourseBlocksUI, setAllCourseBlocksUI] = useState<any>([]);
  const [remainBlocksUI, setRemainBlocksUI] = useState<any>([]);
  const [totalAfterApiDone, setTotalAfterApiDone] = useState<number>(4);
  const [countAfterApiDone, setCountAfterApiDone] = useState<number>(0);
  const [isFirstTimeCallAPiDone, setIsFirstTimeCallAPiDone] = useState(false);
  const [isView, setIsView] = useState<boolean>(false);
  const [gjsProject, setGjsProject] = useState(null);
  const { courseDetail, setCourseDetail } = useCoursesStore()

  const treeData: TreeDataNode[] = get(detailData, "sections", []).map(
    (item: {
      name: string;
      key: string;
      orderNumber: number;
      description: string;
      children: { description: string; name: any; key: any; children: any[] }[];
    }) => {
      return {
        title: item.name,
        key: item.key,
        orderNumber: item.orderNumber,
        isUnit: true,
        description: item.description,
        children: item.children.map(
          (child) => {
            return {
              title: child.name,
              key: child.key,
              description: child.description,
            };
          }
        ),
      };
    }
  );

  useEffect(() => {
    if (mode && mode === 'view') {
      setIsView(true);
    } else {
      setIsView(false);
    }
  }, [mode]);


  useEffect(() => {
    setCurrentUpdateTemplateTime(updateTemplateTime);
    setTimeout(function () {
      stompClient?.publish({
        destination: "/topic/course.template." + params?.id,
        body: JSON.stringify({
          action: 'update',
          time: updateTemplateTime
        }),
      });
    }, 100);
  }, [updateTemplateTime]);

  useEffect(() => {
    editorCustom && reloadAllTemplate(editorCustom, pageBuilderTemplate);
  }, [pageBuilderTemplate]);

  useEffect(() => {
    setTimeout(() => {
      setLoading(false);
    }, 1500);
  }, [treeData]);

  useEffect(() => {
    setTimeout(() => {
      if (!loading) setLoading(true);
    }, 1000);
  }, [tab]);

  useEffect(() => {
    if (tab === '1' && isFirstTimeCallAPiDone) {
      let getAllRemainBlocks = editorCustom?.BlockManager?.getAll()?.filter((x: Block) => {
        return x.getCategoryLabel() === nameBasicBlock || x.getCategoryLabel() === nameLecturersBlock;
      });
      let finalGetAllRemainBasicBlocks = getAllRemainBlocks?.map((x: Block) => {
        return {
          id: x.getId(),
          label: x.getLabel(),
          content: x.getContent(),
          category: x.getCategoryLabel(),
          media: x.getMedia(),
        };
      });
      setRemainBlocksUI(finalGetAllRemainBasicBlocks);
      editorCustom?.BlockManager.clear();
      addMoocCustomDisplayTypePlugin(editorCustom);
      addDetailTemplatesByCoueseId(editorCustom);
      addMyBlocksToCategories(editorCustom);
    }
  }, [tab]);

  useEffect(() => {
    if (countAfterApiDone === totalAfterApiDone) {
      let finalAllCourseBlocksUI: any[] = allCourseBlocksUI;
      if (remainBlocksUI.length > 0) {
        finalAllCourseBlocksUI = finalAllCourseBlocksUI.concat(remainBlocksUI);
      }
      saveToIndexDB('All_Course_Blocks_UI', finalAllCourseBlocksUI);
      const blockManager = editorCustom?.BlockManager;
      const blockManagerAll = blockManager?.getAll();
      let getAllBlocks: any[] = [];

      addBlockToEditor(blockManager, finalAllCourseBlocksUI, () => {
        blockManagerAll?.forEach((x: Block, indexBlock: Number) => {
          getAllBlocks.push({
            id: x.getId(),
            label: x.getLabel(),
            content: x.getContent(),
            category: x.getCategoryLabel(),
            media: x.getMedia(),
          });
          if (indexBlock === blockManagerAll.length - 1) {
            const isBasicBlock = getAllBlocks.filter((x) => {
              return x.category === nameBasicBlock;
            });
            const isMyBlocks = getAllBlocks.filter((x) => {
              return x.category === nameCategoryBlocks;
            });
            const isMyTemplates = getAllBlocks.filter((x) => {
              return x.category === nameCategoryTemplates;
            });
            const isMyLecturers = getAllBlocks.filter((x) => {
              return x.category === nameLecturersBlock;
            });
            const isContactBlock = getAllBlocks.filter((x) => {
              return x.category === nameContactBlock;
            });
            const isCountBlock = getAllBlocks.filter((x) => {
              return x.category === nameCountBlocks;
            });
            const isRoadMapBlock = getAllBlocks.filter((x) => {
              return x.category === nameRoadMapBlocks;
            });
            const isHeaderBlock = getAllBlocks.filter((x) => {
              return x.category === nameHeaderBlocks;
            });
            const isRegisterBlock = getAllBlocks.filter((x) => {
              return x.category === nameRegisterBlocks;
            });
            const isRegisterPolicyBlock = getAllBlocks.filter((x) => {
              return x.category === nameRegisterPolicyBlocks;
            });
            const isConditionBlock = getAllBlocks.filter((x) => {
              return x.category === nameConditionBlocks;
            });
            const isAffiliatedBlock = getAllBlocks.filter((x) => {
              return x.category === nameAffiliatedBlocks;
            });
            const isOpinionBlock = getAllBlocks.filter((x) => {
              return x.category === nameOpinionBlocks;
            });
            const isQuestionBlock = getAllBlocks.filter((x) => {
              return x.category === nameQuestionBlocks;
            });
            const isOtherBlocks = getAllBlocks.filter((x) => {
              return (
                x.category !== "Basic" &&
                x.category !== nameBasicBlock &&
                x.category !== nameCategoryBlocks &&
                x.category !== nameCategoryTemplates &&
                x.category !== nameContactBlock &&
                x.category !== nameLecturersBlock &&
                x.category !== nameCountBlocks &&
                x.category !== nameRoadMapBlocks &&
                x.category !== nameHeaderBlocks &&
                x.category !== nameRegisterBlocks &&
                x.category !== nameRegisterPolicyBlocks &&
                x.category !== nameConditionBlocks &&
                x.category !== nameAffiliatedBlocks &&
                x.category !== nameOpinionBlocks &&
                x.category !== nameQuestionBlocks
              );
            });
            const isMyUI = [
              ...isMyBlocks,
              ...isMyTemplates,
              ...isContactBlock,
              ...isMyLecturers,
              ...isCountBlock,
              ...isRoadMapBlock,
              ...isHeaderBlock,
              ...isRegisterBlock,
              ...isRegisterPolicyBlock,
              ...isConditionBlock,
              ...isAffiliatedBlock,
              ...isOpinionBlock,
              ...isQuestionBlock,
              ...isBasicBlock,
            ];
            const finalAllBlocks = [
              ...isMyUI,
              // ...isOtherBlocks,
            ];
            blockManager?.clear();
            addBlockToEditor(blockManager, finalAllBlocks);
            setCountAfterApiDone(0);
            setAllCourseBlocksUI([]);
            if (!isFirstTimeCallAPiDone) {
              setIsFirstTimeCallAPiDone(true);
            }

            const categories = blockManager?.getCategories();
            categories?.each(category => {
              category.set('open', false);
            });
          }
        });
      });
    }
  }, [countAfterApiDone]);

  useSubscription("/topic/course.template." + params?.id, (message: any) => {
    let payload = JSON.parse(message.body);
    switch (payload.action) {
      case 'update': {
        const time = payload.time;
        if (time > currentUpdateTemplateTime) {
          helpService.waringMessage('Có bản mới được cập nhật', 5, function () {
            getDetailTemplatesByCoueseId((res: any) => {
              if (!isEmpty(res)) {
                setPageBuilderTemplate(res.template);
              }
            });
          })
          setCurrentUpdateTemplateTime(time);
        }
        break;
      }
    }
  });


  const handleClickSuffix = () => {
    setIconVisible(true);
    setTimeout(() => {
      let random;
      let nameRandom = '';
      while (nameRandom.length < 6) {
        random = Math.floor(Math.random() * 10).toString();
        if (!nameRandom.includes(random)) {
          nameRandom += random;
        }
      }
      setNameBlock("block_" + nameRandom);
    }, 1499);
    setTimeout(() => {
      setIconVisible(false);
    }, 1500);
  };

  const onChangeName = (e: any) => {
    setNameBlock(e.target.value);
  };

  const changeName = async () => {
    if (nameBlock !== '') {
      setIconVisible(true);
      const detailDatablock: IBodyBlock = {
        label: nameBlock,
        content: blockUISave,
        courseId: Number(params.id),
      };
      try {
        const apiSaveTemplateBlock = await saveTemplateBlock(detailDatablock);
        const { data } = apiSaveTemplateBlock;
        setIconVisible(false);
        setOpenModal(false);
        setNameBlock('');
        addMyBlocksToCategories(editorCustom);
        helpService.successMessage("Lưu mẫu thành công");
      } catch (error: any) {
        setIconVisible(false);
      }
    } else {
      helpService.errorMessage("Chưa nhập tên mẫu");
    }
  };

  const changeContentSummry = async () => {

  };

  const closeModal = () => {
    setNameBlock('');
    setOpenModal(false);
  };

  const warningSavedDraft = (ed: Editor | undefined, res: any) => {
    Modal.confirm({
      title: t("Xác nhận", "Xác nhận"),
      content:
        t("Bạn có một bản lưu nháp. Bạn có muốn tiếp tục chỉnh sửa lưu nháp ?", "Bạn có một bản lưu nháp. Bạn có muốn tiếp tục chỉnh sửa lưu nháp ?"),
      className: "modal-custom",
      okButtonProps: {
        className: "btn",
      },
      cancelButtonProps: {
        className: "btn btn-outlined",
      },
      okText: t("Tiếp tục chỉnh sửa", "Tiếp tục chỉnh sửa"),
      cancelText: t("Không", "Không"),
      onOk: () => {
        setIsReadyNextTab(true);
        ed?.Components.clear();
        reloadAllTemplate(ed, res.template_draft);
      },
      onCancel: () => {
        setIsReadyNextTab(true);
        if (res.template !== '') {
          ed?.Components.clear();
          reloadAllTemplate(ed, res.template);
        }
      },
    });
  };

  const saveDetailTemplatesByCoueseId = (type: string, ed: Editor) => {
    getIdIndexDB('isClearToSave', (check: any) => {
      // if (check) {
      //   helpService.loadingProcess();
      getIdIndexDB("courseSavedTemplete-" + params?.id, (val: any) => {
        if (val) {
          const gjsProject = localStorage.getItem('gjsProject');
          if (gjsProject) {
            const parseGjsProject = JSON.parse(gjsProject);
            val.gjsProject = parseGjsProject;
          }
          const detailDataTemplates: IBodyTemplates = {
            template: toBase64(JSON.stringify(val)),
            templateStatusCode: type,
            isTemplateSample: saveDraft,
          };
          saveTemplates(params?.id, detailDataTemplates).then((res) => {
            helpService.closeProcess();
            setDirty(false);
            setUpdateTemplateTime(new Date().getTime());
            helpService.successMessage(res.data.data);
            if (saveDraft) {
              addMyBlocksToCategories(ed);
            }
          });
        } else {
          message.error(t("Không có thay đổi!", "Không có thay đổi!"));
        }
      });
      // } else {
      //   helpService.errorMessage('Đang bị lỗi trùng tên thẻ định danh !!!');
      // }
    });
  };

  const getDetailTemplatesByCoueseId = (cb?: any) => {
    getTemplateByCourseId(params?.id).then((res) => {
      const { data } = res.data;
      cb && cb(data);
    });
  };

  const AdvancedSettingReplace = forwardRef(({ change }: any, ref: Ref<RefComponentClass>) => {
  const { t } = useTranslation();
    const [componentClass, setComponentClass] = useState('');
    useImperativeHandle(ref, () => ({ updateComponentClass: updateComponentClass }));

    function updateComponentClass(value: string) {
      setComponentClass(value);
    }

    return (
      <div className="config-view-ctn">
        <div className="gjs-traits-cs gjs-one-bg gjs-two-color">
          <div className="gjs-trait-categories" data-categories=''></div>
          <div className="gjs-traits-empty-c gjs-traits-c" data-no-categories=''>
            <Select
              //showSearch
              value={componentClass}
              style={{
                width: 200,
              }}
              onChange={(event) => {
                change({ event });
                setComponentClass(event);
              }}
              options={[
                {
                  options: [
                    {
                      label: <span>{t("Không sử dụng", "Không sử dụng")}</span>,
                      value: '',
                    },
                  ],
                },

                {
                  label: <span>{t("Khóa học", "Khóa học")}</span>,
                  title: t("Khóa học", "Khóa học"),
                  options: [
                    {
                      label: <span>{t("Giá của khóa học", "Giá của khóa học")}</span>,
                      value: 'CoursePriceText',
                    },
                    {
                      label: <span>{t("Nút bấm thẻ ghi danh", "Nút bấm thẻ ghi danh")}</span>,
                      value: 'CourseTagAction',
                    },
                    {
                      label: <span>{t("Thời gian", "Thời gian")}</span>,
                      value: 'CourseTime',
                    },
                  ],
                },
                {
                  label: <span>{t("Giảng viên", "Giảng viên")}</span>,
                  title: t("Giảng viên", "Giảng viên"),
                  options: [
                    {
                      label: <span>{t("Tên tác giả", "Tên tác giả")}</span>,
                      value: 'TeacherName',
                    },
                  ],
                },
              ]}
            />
          </div>
        </div>
      </div>
    );
  });

  //cài đặt hoạt động custom
  const addMoocCustomDisplayTypePlugin = (editor: Editor | undefined) => {

    editor?.StyleManager.addType("advanced-setting-replace", {
      create: function ({ props, createdEl, change }) {
        let p = props as CustomDisplayPros;
        const el = document.createElement("div");
        el.classList.add("config-view");
        const root = createRoot(el);
        root.render(<AdvancedSettingReplace change={change} ref={replaceComponentClassRef} />);
        return el;
      },
      emit({ }, { event }) {
        const selectedComponent = editor.getSelected();
        if (!event) {
          selectedComponent?.removeAttributes('component-class');
        } else {
          selectedComponent?.addAttributes({ 'component-class': event });
        }
      },
      update() {
      },
      destroy() {
      },
    });
    editor?.StyleManager.addType("advanced-setting-route", {
      create({ props, createdEl, change }) {
        const el = document.createElement("div");
        el.classList.add("tree-select-container");
        el.setAttribute("id", "tree-select-container");
        const root = createRoot(el);
        root.render(<MyDataTree editor={editor} change={change} />);
        return el;
      },
      emit({ props, updateStyle }, { event }, info) {
        const { node } = info;
        const selectedComponent = editor.getSelected();
        let componentText = selectedComponent?.getEl();

        const findItemByKey: any = (dataArray: string | any[], key: any) => {
          // Iterate over the array to find the item with the matching key
          for (let i = 0; i < dataArray.length; i++) {
            const item = dataArray[i];
            if (item.key === key) {
              return item;
            }
            // If the item has children, recursively search through them
            if (item.children) {
              // @ts-ignore
              const foundItem = findItemByKey(item.children, key);
              if (foundItem) {
                return foundItem;
              }
            }
          }
          return null;
        };

        // @ts-ignore
        function containsTitles(obj: TreeDataNode, title: any) {
          // Base case: If obj is null or undefined, return false
          if (obj.title === title) {
            return obj;
          }
          if (obj.children && obj.children.length) {
            for (let i = 0; i < obj.children.length; i++) {
              // @ts-ignore
              const result = containsTitles(obj.children[i], title);
              if (result) {
                return result;
              }
            }
          }
          return null;
        }

        // @ts-ignore
        if (
          selectedComponent &&
          componentText &&
          selectedComponent?.attributes.type === "text"
        ) {
          const titleData: TreeDataNode | undefined = treeData.find((item) =>
            event.includes(item.key)
          );

          if (titleData && titleData.title) {
            componentText.innerText = titleData.title as string;
          }
          if (!titleData) {
            componentText.innerText = '';
          }
        }
        if (
          selectedComponent &&
          selectedComponent.components().length >= 2 &&
          event.length > 1
        ) {
          selectedComponent.getChildAt(1).forEachChild((child) => {
            let elementTitleStyle = selectedComponent
              ?.getChildAt(0)
              .getEl()?.style;
            let elementChildStyle = selectedComponent
              ?.getChildAt(1)
              .getEl()?.style;
            const elementTitle = selectedComponent?.getChildAt(0).getEl();
            let element = child.getEl();
            if (elementTitleStyle && elementChildStyle) {
              elementTitleStyle.display = "block";
              elementChildStyle.display = "block";
            }
            if (element && child.attributes.type === "text") {
              event.forEach((key: any, index: number) => {
                if (elementTitle?.tagName === "H2") {
                  if (info.checked && node.orderNumber) {
                    elementTitle.style.display = "block";
                    elementTitle.textContent = node.title;
                  }
                  if (!info.checked && node.orderNumber) {
                    elementTitle.style.display = "none";
                  }
                }
                if (element?.tagName === "H3") {
                  const el = selectedComponent?.getChildAt(1).find("h3");
                  el?.forEach((elt: any, num: any) => {
                    if (info.checked) {
                      elt.getEl().style.display = "block";
                    }
                    if (
                      info.checked &&
                      !node.orderNumber &&
                      elt.getEl().textContent === node.title
                    ) {
                      elt.getEl().style.display = "block";
                    }
                    if (
                      !info.checked &&
                      !node.orderNumber &&
                      elt.getEl().textContent === node.title
                    ) {
                      elt.getEl().style.display = "none";
                    }
                  });
                }
              });
            }
          });
        }
        if (
          selectedComponent &&
          selectedComponent.components().length >= 2 &&
          event.length === 0
        ) {
          selectedComponent.getChildAt(0).forEachChild((child) => {
            let elementTitleStyle = selectedComponent
              ?.getChildAt(0)
              .getEl()?.style;
            let elementStyle = selectedComponent?.getChildAt(1).getEl()?.style;
            if (elementStyle && elementTitleStyle) {
              elementTitleStyle.display = "none";
              elementStyle.display = "none";
            }
          });
        }
      },
      update({ value, el }) {
      },
      destroy() {
      },
    });
  };

  const MyDataTree = ({ editor, change }: { editor: Editor; change: any }) => {
  const { t } = useTranslation();
    const initialData = extractKeys(treeData);
    const checkValueData = (event: any, info: any) => {
      change({ event }, info);
    };

    return (
      <>
        {treeData.length > 0 ? (
          <Tree
            checkable
            treeData={treeData}
            defaultCheckedKeys={initialData}
            onCheck={(event, info) => checkValueData(event, info)}
            onSelect={(event) => change({ event })}
          />
        ) : (
          <>
            <span>{t("Khóa học chưa có lộ trình", "Khóa học chưa có lộ trình")}</span>
          </>
        )}
      </>
    );
  };

  const addDetailTemplatesByCoueseId = (editor: Editor | undefined) => {
    setDirty(false);
    getDetailTemplatesByCoueseId((res: any) => {
      if (!isEmpty(res)) {
        const checkUIIsNull = checkTemplateIsNull(editor);
        if (checkUIIsNull && res.template === null && res.template_draft === null && res.template_status_code === null) {
          loadDefaultUI(editor);
          setIsReadyNextTab(true);
        } else if (res.template_draft !== null && res.template_status_code === "published") {
          warningSavedDraft(editor, res);
        } else {
          setIsReadyNextTab(true);
          reloadAllTemplate(editor, res.template);
          const template = JSON.parse(res.template);

          setGjsProject(template.gjsProject);
        }
      }
    });
  };

  useEffect(() => {
    if (editorCustom && gjsProject) {
      // Check if project data exists in localStorage first
      const localStorageKey = editorCustom.StorageManager.getConfig().id || 'gjsProject';
      const savedData = localStorage.getItem(localStorageKey);
      // If there's no localStorage data or you want to override it, load the API data
      if (!savedData) {
        editorCustom.loadProjectData(gjsProject); // Load the project data from the API
      } else {
        console.log('Local project data found, using localStorage');
      }
    }
  }, [editorCustom, gjsProject]);

  const addMyBlocksToCategories = async (editor: Editor | undefined) => {
    try {
      let customCourseBlocksUI: any[] = [];
      saveToIndexDB('All_Course_Blocks_UI', []);

      if (treeData.length > 0) {
        const data = roadMapBlockGenerete(treeData);
        convertItemToBlock(customCourseBlocksUI, data);
        afterCallApiDone(editor, customCourseBlocksUI);
      } else {
        const data = roadMapBlockGenerete([]);
        convertItemToBlock(customCourseBlocksUI, data);
        afterCallApiDone(editor, customCourseBlocksUI);
      }

      const [apiGetTemplateCategory, apiGetStudentRegisterCourse, apiGetReviewCourse, apiPostCourseSearch, apiGetDataGeneral] = await Promise.all([
        getTemplateCategory(),
        getStudentRegisterCourse(get(detailData, "id", 0)),
        getReviewCourse(get(detailData, "id", 0)),
        postCourseSearch({ pageSize: 0 }),
        getDataGeneral(get(detailData, "id", 0))
      ]);
      const dataBlocks = apiGetTemplateCategory.data;
      if (dataBlocks) {
        let customCourseBlocksUI: any[] = [];
        dataBlocks.data.forEach((x: any) => {
          if (x.is_template === 0) {
            x.category = nameCategoryBlocks;
          }
          if (x.is_template === 1) {
            x.category = nameCategoryTemplates;
          }
          const templateContent = x.content;
          if (templateContent !== null && isValidJSON(templateContent)) {
            const blockUI = JSON.parse(templateContent);
            x.html = blockUI.html;
            x.css = blockUI.css;
          }
          convertItemToBlock(customCourseBlocksUI, x);
        });
        convertItemToBlock(customCourseBlocksUI, questionBlockCustom());
        convertItemToBlock(customCourseBlocksUI, opinionBlockCustom());
        convertItemToBlock(customCourseBlocksUI, contactBlockCustom());
        convertItemToBlock(customCourseBlocksUI, headerBlockLogo());
        convertItemToBlock(customCourseBlocksUI, headerBlockName());
        convertItemToBlock(customCourseBlocksUI, registerBlock1());
        convertItemToBlock(customCourseBlocksUI, registerBlock2());
        convertItemToBlock(customCourseBlocksUI, registerBlock3());
        convertItemToBlock(customCourseBlocksUI, registerPolicy());
        convertItemToBlock(customCourseBlocksUI, affiliatedBlock());
        convertItemToBlock(customCourseBlocksUI, spanBlockCustom());
        afterCallApiDone(editor, customCourseBlocksUI);
      }

      const dataCountStudents = apiGetStudentRegisterCourse.data;
      const dataCountReviews = apiGetReviewCourse.data;
      if (dataCountStudents && dataCountReviews) {
        convertItemToBlock(customCourseBlocksUI, countBlockGenerete(dataCountReviews, dataCountStudents));
        afterCallApiDone(editor, customCourseBlocksUI);
      } else {
        convertItemToBlock(customCourseBlocksUI, countBlockGenerete({}, {}));
        afterCallApiDone(editor, customCourseBlocksUI);
      }

      const dataAllOptionCourse = apiPostCourseSearch.data.data.data.filter((data: any) => data.status === 13);
      const preCourses = apiGetDataGeneral.data.data.preCourses;
      const preSkills = apiGetDataGeneral.data.data.preSkills;
      let preRenderSkills: any = [];
      let preRenderCourse: any = [];
      if (preCourses && preSkills) {
        optionsSkills.forEach((x: any) => {
          preSkills.forEach((y: any) => {
            if (y === x.code) {
              preRenderSkills.push(x.label);
            }
          });
        });
        dataAllOptionCourse.forEach((x: any) => {
          preCourses.forEach((y: any) => {
            if (y === x.code) {
              preRenderCourse.push(x.name);
            }
          });
        });
        convertItemToBlock(customCourseBlocksUI, conditionBlockGenerete(preRenderCourse, preRenderSkills));
        afterCallApiDone(editor, customCourseBlocksUI);
      } else {
        convertItemToBlock(customCourseBlocksUI, conditionBlockGenerete([], []));
        afterCallApiDone(editor, customCourseBlocksUI);
      }
    } catch {
    }
  };

  const afterCallApiDone = (editor: Editor | undefined, data: any[]) => {
    setCountAfterApiDone(x => x + 1);
    setAllCourseBlocksUI((x: any) => x.concat(data));
  };

  const syncData = () => {
    setIsOpenSync(true);
  };

  const handleCancel = () => {
    setIsOpenSync(false);
  };

  function MyComponentWithUseEditor() {
  const { t } = useTranslation();
    const editor = useEditor();
    const defaultValue = extractKeys(treeData);
    const [selectValue, setSelectValue] = useState<Key[] | { checked: Key[]; halfChecked: Key[] }>(defaultValue);
    const [checkValue, setCheckValue] = useState<Key[] | { checked: Key[]; halfChecked: Key[] }>([]);
    const [valueNodes, setValueNodes] = useState<any[]>([]);

    const [infoSelect, setInfoSelect] = useState({});
    const [isDisabledSync, setIsDisabledSync] = useState(false);

    // Lọc ra checkedNodes dưới dạng treeData
    function filterTreeData(treeData: any, checkedNodes: any) {
      const checkedKeysInCheckNodes = new Set(
        checkedNodes.map((node: any) => node.key)
      );

      function filterNodes(nodes: any) {
        return nodes.map((node: any) => {
          if (node.children) {
            const filteredChildren = filterNodes(node.children).filter(
              (child: any) => checkedKeysInCheckNodes.has(child.key)
            );
            return {
              ...node,
              children: filteredChildren,
            };
          }
          return node;
        });
      }

      return filterNodes(treeData);
    }

    const handleSync = () => {
      const component = editor.Components.getComponent();
      const roadmap = component?.getEl()?.querySelector("#roadmap-1");
      const sectionUnitOld = component?.getEl()?.querySelectorAll('div[name="section-unit"]');

      const sectionUnitEl = component?.getEl()?.querySelector('div[name="section-unit"]') as HTMLElement;

      if (infoSelect && valueNodes.length > 0) {
        // Thêm chương khi đồng bộ
        if (roadmap && sectionUnitOld && sectionUnitOld.length < valueNodes.length) {
          // Chênh lệch số lượng của khối hiện tại và số lượng bài chương đồng bộ
          const checkDiff = valueNodes.length - sectionUnitOld.length;
          for (let i = 0; i < checkDiff; i++) {
            if (sectionUnitEl) {
              // Sao chép nội dung và các thuộc tính từ elLi
              const contentHtml = sectionUnitEl.innerHTML;
              const newComponent = editor.addComponents(`<div>${contentHtml}</div>`);

              if (newComponent && newComponent.length > 0) {
                const component = newComponent[0];
                const componentEl = component.getEl();

                if (componentEl instanceof HTMLElement) {
                  // Sao chép lớp CSS và thuộc tính inline từ elLi
                  if (sectionUnitEl.className) {
                    componentEl.className = sectionUnitEl.className;
                  }
                  componentEl.style.cssText = sectionUnitEl.style.cssText;

                  // Thêm thuộc tính name cho div được clone
                  componentEl.setAttribute('name', 'section-unit');

                  // Thêm vào <div> trong DOM
                  if (roadmap) {
                    roadmap.appendChild(componentEl);
                  } else {
                    console.error('No <div> found in DOM');
                  }
                } else {
                  console.error('Component element is undefined');
                }
              }
            }
          }
        }

        const titleEl = component?.getEl()?.querySelectorAll(".bg-white > .text-xl");
        const titleUnit = component?.getEl()?.querySelectorAll("#roadmap-1 h2");
        const sectionUnit = component?.getEl()?.querySelectorAll('div[name="section-unit"]');
        const sectionContent = component?.getEl()?.querySelectorAll("h3[name='roadmap-lesson']");
        const sectionChildUnit = component?.getEl()?.querySelectorAll('div[name="section-unit"]');
        let saveLi: any; // Biến lưu trữ thẻ Li trường hợp không có bài giảng

        // @ts-ignore
        titleEl.forEach((el, i) => {
          valueNodes.map((elChild: any, index: number) => {
            if (index === i) {
              el.textContent = elChild.title;
            }
          });
        });
        titleUnit &&
          titleUnit.forEach((el1, i) => {
            valueNodes.map((elChild: any, index: number) => {
              if (index === i) {
                el1.textContent = elChild.title;
              }
            });
          });
        // @ts-ignore
        sectionUnit.forEach((el, i0) => {
          if (treeData[i0]) {
            // @ts-ignore
            el["style"].display = 'block'
          } else {
            // @ts-ignore
            el["style"].display = 'none'
          }
          // @ts-ignore
          sectionChildUnit.forEach((el1, i1) => {
            if (i0 === i1) {
              const elUl = el1.querySelector("div[name='section-unit'] ul");
              if (el1.querySelector("li")) {
                saveLi = el1.querySelector("li");
              }
              const elLi = saveLi;

              valueNodes.map((item: any, indexTree) => {
                // Thêm bài giảng khi đồng bộ
                if (elUl && elUl.querySelectorAll("li").length < item.children.length) {
                  // Chênh lệch số lượng của khối hiện tại và số lượng bài giảng đồng bộ
                  const checkDiff = item.children.length - elUl.querySelectorAll("li").length;
                  for (let i = 0; i < checkDiff; i++) {
                    if (elLi) {
                      // Sao chép nội dung và các thuộc tính từ elLi
                      const contentHtml = elLi.innerHTML;
                      const newComponent = editor.addComponents(`<li>${contentHtml}</li>`);

                      if (newComponent && newComponent.length > 0) {
                        const component = newComponent[0];
                        const componentEl = component.getEl();

                        if (componentEl) {
                          // Sao chép lớp CSS và thuộc tính inline từ elLi
                          if (elLi.className) {
                            componentEl.className = elLi.className;
                          }
                          componentEl.style.cssText = elLi.style.cssText;

                          // Thêm vào <ul> trong DOM
                          if (elUl) {
                            elUl.appendChild(componentEl);
                          } else {
                            console.error('No <ul> found in DOM');
                          }
                        } else {
                          console.error('Component element is undefined');
                        }
                      } else {
                        console.error('Failed to create new component');
                      }
                    }
                  }
                }

                // Cài hiển thị những khối không được đồng bộ
                if (i1 + 1 > valueNodes.length) {
                  if (el1 instanceof HTMLElement) {  // Kiểm tra nếu el1 là một phần tử HTML
                    el1.style.display = "none";
                  } else if (el1 instanceof HTMLElement) {
                    el1.style.display = "flex";
                  }
                }

                const listEl = el1.querySelectorAll("li");
                if (indexTree === i1) {
                  // Loại bỏ những li không được đồng bộ
                  listEl.forEach((el, i) => {
                    if (i + 1 > item.children.length) {
                      el["style"].display = "none";
                    } else {
                      el["style"].display = "flex";
                    }
                  })

                  const headingEl = el1.querySelectorAll("h3[name='title-lesson']");
                  const contentEl = el1.querySelectorAll("[class='text-gray-700']");

                  headingEl.forEach((el2, i2) => {
                    item.children?.map((child: any, index: number) => {
                      if (i2 === index) {
                        el2.textContent = child.title;
                      }
                    });
                    if (item.children?.length === 0) {
                      el2.textContent = '';
                    }
                  });
                  contentEl.forEach((el2, i2) => {
                    item.children?.map((child: any, index: number) => {
                      if (i2 === index) {
                        el2.textContent = child.description ? child.description : t("Chưa có mô tả", "Chưa có mô tả");
                      }
                    });
                    if (item.children?.length === 0) {
                      el2.textContent = '';
                    }
                  });
                }
              });
            }
          });
        });
        sectionContent?.forEach((el2, i) => {
          if (valueNodes.length > 0) {
            valueNodes.map((el: any, index: number) => {
              if (index === i) {
                el2.textContent = el.title;
              }
            });
          }
        });
        message.success(t("Đồng bộ thành công", "Đồng bộ thành công"));
        setIsOpenSync(false);
      } else {
        // Thêm chương khi đồng bộ
        if (roadmap && sectionUnitOld && sectionUnitOld.length < treeData.length) {
          // Chênh lệch số lượng của khối hiện tại và số lượng bài chương đồng bộ
          const checkDiff = treeData.length - sectionUnitOld.length;
          for (let i = 0; i < checkDiff; i++) {
            if (sectionUnitEl) {
              // Sao chép nội dung và các thuộc tính từ elLi
              const contentHtml = sectionUnitEl.innerHTML;
              const newComponent = editor.addComponents(`<div>${contentHtml}</div>`);

              if (newComponent && newComponent.length > 0) {
                const component = newComponent[0];
                const componentEl = component.getEl();

                if (componentEl) {
                  // Sao chép lớp CSS và thuộc tính inline từ elLi
                  if (sectionUnitEl.className) {
                    componentEl.className = sectionUnitEl.className;
                  }
                  componentEl.style.cssText = sectionUnitEl.style.cssText;

                  // Thêm thuộc tính name cho div được clone
                  componentEl.setAttribute('name', 'section-unit');

                  // Thêm vào <div> trong DOM
                  if (roadmap) {
                    roadmap.appendChild(componentEl);
                  } else {
                    console.error('No <div> found in DOM');
                  }
                } else {
                  console.error('Component element is undefined');
                }
              }
            }
          }
        }

        const titleEl = component?.getEl()?.querySelectorAll(".bg-white > .text-xl");
        const titleUnit = component?.getEl()?.querySelectorAll("#roadmap-1 h2");
        const sectionUnit = component?.getEl()?.querySelectorAll('div[name="section-unit"]');
        const sectionContent = component?.getEl()?.querySelectorAll("h3[name='roadmap-lesson']");
        const sectionChildUnit = component?.getEl()?.querySelectorAll('div[name="section-unit"]');
        let saveLi: any; // Biến lưu trữ thẻ Li trường hợp không có bài giảng

        // @ts-ignore
        titleEl.forEach((el, i) => {
          treeData.map((elChild: any, index: number) => {
            if (index === i) {
              el.textContent = elChild.title;
            }
          });
        });
        titleUnit &&
          titleUnit.forEach((el1, i) => {
            treeData.map((elChild: any, index: number) => {
              if (index === i) {
                el1.textContent = elChild.title;
              }
            });
          });
        // @ts-ignore
        sectionUnit.forEach((el, i0) => {
          if (treeData[i0]) {
            // @ts-ignore
            el["style"].display = 'block'
          } else {
            // @ts-ignore
            el["style"].display = 'none'
          }
          // @ts-ignore
          sectionChildUnit.forEach((el1, i1) => {
            if (i0 === i1 && treeData[i0]) {
              const elUl = el1.querySelector("div[name='section-unit'] ul");
              if (el1.querySelector("li")) {
                saveLi = el1.querySelector("li");
              }
              const elLi = saveLi;

              treeData.map((item: any, indexTree) => {
                // Thêm bài giảng khi đồng bộ
                if (elUl && elUl.querySelectorAll("li").length < item.children.length) {
                  // Chênh lệch số lượng của khối hiện tại và số lượng bài giảng đồng bộ
                  const checkDiff = item.children.length - elUl.querySelectorAll("li").length;
                  for (let i = 0; i < checkDiff; i++) {
                    if (elLi) {
                      // Sao chép nội dung và các thuộc tính từ elLi
                      const contentHtml = elLi.innerHTML;
                      const newComponent = editor.addComponents(`<li>${contentHtml}</li>`);

                      if (newComponent && newComponent.length > 0) {
                        const component = newComponent[0];
                        const componentEl = component.getEl();

                        if (componentEl) {
                          // Sao chép lớp CSS và thuộc tính inline từ elLi
                          if (elLi.className) {
                            componentEl.className = elLi.className;
                          }
                          componentEl.style.cssText = elLi.style.cssText;

                          // Thêm vào <ul> trong DOM
                          if (elUl) {
                            elUl.appendChild(componentEl);
                          } else {
                            console.error('No <ul> found in DOM');
                          }
                        } else {
                          console.error('Component element is undefined');
                        }
                      } else {
                        console.error('Failed to create new component');
                      }
                    }
                  }
                }

                const listEl = el1.querySelectorAll("li");

                if (indexTree === i0) {
                  // Loại bỏ những li không được đồng bộ
                  listEl.forEach((el, i) => {
                    if (i + 1 > item.children.length) {
                      el["style"].display = "none";
                    } else {
                      el["style"].display = "flex";
                    }
                  })

                  const headingEl = el1.querySelectorAll("h3[name='title-lesson']");
                  const contentEl = el1.querySelectorAll("p.text-gray-700");

                  headingEl.forEach((el2, i2) => {
                    item.children.map((child: any, index: number) => {
                      if (i2 === index) {
                        el2.textContent = child.title;
                      }
                    });
                    if (item.children.length === 0) {
                      el2.textContent = '';
                    }
                  });
                  contentEl.forEach((el3, i3) => {
                    item.children.map((child: any, index: number) => {
                      if (i3 === index) {
                        el3.textContent = child.description ? child.description : t("Chưa có mô tả", "Chưa có mô tả");
                      }
                    });
                    if (item.children.length === 0) {
                      el3.textContent = '';
                    }
                  })
                }
              });
            }
          });
        });
        sectionContent?.forEach((el2, i) => {
          if (valueNodes.length > 0) {
            dataTree.map((el: any, index: number) => {
              if (index === i) {
                return (el2.textContent = el.title);
              } else {
                return (el2.textContent = '');
              }
            });
          }
        });
        message.success(t("Đồng bộ thành công", "Đồng bộ thành công"));
        setIsOpenSync(false);
      }
    };

    const handleCheck: TreeProps["onCheck"] = (checkedKeys, info) => {
      const { checkedNodes } = info;
      setSelectValue(checkedKeys);
      setInfoSelect(info);
      setIsDisabledSync(false);
      // @ts-ignore
      setValueNodes(checkedNodes.filter((node) => node.isUnit).sort((a, b) => a.orderNumber - b.orderNumber));
      if (isArray(checkedKeys) && checkedKeys.length === 0) {
        setIsDisabledSync(true);
      }
      const result = filterTreeData(treeData, checkedNodes);
      setValueNodes(result.filter((node: any) => node.children.length > 0));
    };

    const onCheckAll = (checked: boolean) => {
      if (checked) {
        // Collect all keys and info when selecting all
        const allKeys:
          | any[]
          | { checked: Key[]; halfChecked: Key[] }
          | ((
            prevState:
              | Key[]
              | {
                checked: Key[];
                halfChecked: Key[];
              }
          ) => Key[] | { checked: Key[]; halfChecked: Key[] }) = [];
        const allInfo: any[] = [];

        const collectKeysAndInfo = (nodes: any[]) => {
          nodes.forEach((node) => {
            allKeys.push(node.key);
            allInfo.push(node); // Assuming you want all node info
            if (node.children) {
              collectKeysAndInfo(node.children);
            }
          });
        };

        collectKeysAndInfo(treeData);
        setValueNodes(allInfo.filter((node) => node.isUnit));
        setSelectValue(allKeys);
        setIsDisabledSync(false);
      } else {
        setSelectValue([]);
        setIsDisabledSync(true);
      }
    };
    return (
      <>
        <Modal
          open={isOpenSync}
          title={t("Đồng bộ", "Đồng bộ")}
          okText={t("Đồng bộ", "Đồng bộ")}
          cancelText={t("Huỷ", "Huỷ")}
          onCancel={handleCancel}
          onOk={handleSync}
          okButtonProps={{
            disabled: isDisabledSync || treeData.length <= 0,
          }}
        >
          <>
            {treeData.length > 0 ? (
              <>
                <div className="select-data">
                  {isArray(selectValue) && selectValue?.length > 0 ? (
                    <a onClick={() => onCheckAll(false)}>{t("Bỏ chọn tất cả", "Bỏ chọn tất cả")}</a>
                  ) : (
                    <a onClick={() => onCheckAll(true)}>{t("Chọn tất cả", "Chọn tất cả")}</a>
                  )}
                </div>
                <div className="sync-data--tree">
                  <Tree
                    checkable
                    treeData={treeData}
                    defaultSelectedKeys={defaultValue}
                    defaultCheckedKeys={defaultValue}
                    defaultExpandedKeys={defaultValue}
                    height={233}
                    onCheck={handleCheck}
                    checkedKeys={selectValue}
                  />
                </div>
              </>
            ) : (
              <span>{t("Khóa học chưa có lộ trình để đồng bộ", "Khóa học chưa có lộ trình để đồng bộ")}</span>
            )}
          </>
        </Modal>
      </>
    );
  }

  useEffect(() => {
    const fetchDetail = async () => {
      try {
        await getAdditionalForTemplate(params?.id).then(
          (res) => {
            const { data } = res.data;
            setCourseDetail(data)
          }
        );
      } catch (error) {
        console.error(error)
      }
    };
    fetchDetail()
  }, [reload])

  const onEditor = (editor: Editor) => {
    setEditorCustom(editor);
    const panelManager = editor.Panels;
    editor.getConfig().avoidInlineStyle = false;
    editor.getConfig().forceClass = false;
    const panelOpntionsId = "options";
    const panelViewsId = "views";
    const commandToAdd = "tlb-save-block";
    // panelManager.removeButton(panelOpntionsId, 'export-template');
    // panelManager.removeButton(panelOpntionsId, 'gjs-open-import-webpage');
    // panelManager.removeButton(panelViewsId, 'open-layers');
    let titles = document.querySelectorAll("*[title]");
    for (let i = 0; i < titles.length; i++) {
      let el = titles[i];
      let title = el.getAttribute("title");
      title = title ? title.trim() : '';
      if (!title) break;
      el.setAttribute("data-tooltip", title);
      el.setAttribute("title", '');
      el.setAttribute("data-tooltip", '');
    }
    panelManager.getButton(panelOpntionsId, "sw-visibility")?.set("active", 1);
    const optionBtns = [
      ["sw-visibility", "Xem thành phần"],
      ["preview", "Xem trước"],
      ["fullscreen", "Toàn màn hình"],
      ["export-template", "Xem mã nguồn"],
      ["undo", "Hoàn tác"],
      ["redo", "Làm lại"],
      ["gjs-open-import-webpage", "Nhập mã nguồn"],
      ["canvas-clear", "Xóa"],
    ];

    const viewBtns = [
      ["open-sm", "Quản lý định dạng"],
      ["open-tm", "Cài đặt"],
      ["open-layers", "Quản lý lớp"],
      ["open-blocks", "Chọn mẫu"],
    ];

    optionBtns.forEach((item, i) => {
      panelManager.getButton(panelOpntionsId, item[0])?.set("attributes", {
        title: item[1],
        "data-tooltip": item[1],
        "data-tooltip-pos": "top",
      });
    });

    viewBtns.forEach((item, i) => {
      if (i === (viewBtns.length - 1)) {
        panelManager.getButton(panelViewsId, item[0])?.set("attributes", {
          title: item[1],
          "data-tooltip": item[1],
          "data-tooltip-pos": "left",
        });
      } else {
        panelManager.getButton(panelViewsId, item[0])?.set("attributes", {
          title: item[1],
          "data-tooltip": item[1],
          "data-tooltip-pos": "top",
        });
      }
    });

    panelManager.addButton(panelOpntionsId, {
      id: "open-fonts-popup",
      className: "gjs-btn-custom gjs-pn-open-fonts-popup",
      active: false,
      attributes: {
        title: '',
        "data-tooltip": "Fonts",
        "data-tooltip-pos": "top",
      },
      command() {
        editor.runCommand('open-fonts');
        const titleModal = document.querySelector('.gjs-mdl-title');
        if (titleModal) {
          titleModal.textContent = 'Lựa chọn fonts';
        }

        const inputSearchFont = document.querySelector('.silex-bar input');
        if (inputSearchFont) {
          inputSearchFont.setAttribute('placeholder', 'Tìm fonts...');
        }

        const btnInstallFont = document.querySelector('.silex-bar .silex-button');
        if (btnInstallFont) {
          btnInstallFont.textContent = 'Cài đặt';
        }

        const titleInstalledFonts = document.querySelector('.silex-form__element h2');
        if (titleInstalledFonts) {
          titleInstalledFonts.textContent = 'Các fonts đã cài';
        }

        const btnDeleteFont = document.querySelectorAll('.silex-list__item__footer .silex-button');
        if (btnDeleteFont) {
          btnDeleteFont.forEach((x) => {
            x.textContent = 'Xóa';
          });
        }

        const btnCloseFontsPopup = document.querySelector('.silex-form footer input[type="button"]');
        if (btnCloseFontsPopup) {
          btnCloseFontsPopup.setAttribute('value', 'Đóng');
        }

        const btnSubmitFontsPopup = document.querySelector('.silex-form footer input[type="submit"]');
        if (btnSubmitFontsPopup) {
          btnSubmitFontsPopup.setAttribute('value', 'Lưu');
        }
      },
    });

    panelManager.addButton(panelOpntionsId, {
      id: "save-all-template-draft",
      className: "gjs-btn-custom gjs-pn-btn-save-draft",
      active: false,
      attributes: {
        title: '',
        "data-tooltip": t("Lưu nháp", "Lưu nháp"),
        "data-tooltip-pos": "top",
      },
      command() {
        confirmMessage(
          "Lưu nháp",
          1,
          "Bạn có chắc muốn lưu nháp không?",
          () => {
            saveDetailTemplatesByCoueseId("draft", editor);
          }
        );
      },
    });

    panelManager.addButton(panelOpntionsId, {
      id: "save-all-template",
      className: "gjs-btn-custom gjs-pn-btn-save",
      active: false,
      attributes: {
        title: '',
        "data-tooltip": t("Lưu", "Lưu"),
        "data-tooltip-pos": "top",
      },
      command() {
        saveDraft = false;
        confirmMessage("Xác nhận lưu giao diện trình bày?",
          1,
          '',
          () => {
            saveDetailTemplatesByCoueseId("published", editor);
          },
          () => {
          },
          true,         
        );
      },
    });

    editor.on("component:selected", (res) => {
      if (mode === 'view') {
        res.set({
          editable: false,
          resizable: false
        });

        // Prevent deletion
        // Override the remove method to prevent deletion
        res.remove = function () {
          return this;
        }
      }
      const componentClass = res?.getAttributes()['component-class'];
      replaceComponentClassRef.current?.updateComponentClass(componentClass);
      const settingsRoute = document.querySelector('.gjs-sm-property__settings-route');
      if (componentClass === 'RoadMapWrapperComponent' || componentClass === 'RoadMapComponent') {
        settingsRoute?.classList.remove('h-0');
        settingsRoute?.classList.remove('overflow-hidden');
      } else {
        settingsRoute?.classList.add('h-0');
        settingsRoute?.classList.add('overflow-hidden');
      }
      const toolTipTextAction = [
        'In đậm', 'In nghiêng', 'Gạch chân', 'Gạch ngang', 'Link', 'Chỉnh sửa'
      ]
      const getAllActionIcon = document.querySelectorAll('.gjs-rte-action')
      getAllActionIcon.forEach((item, i) => {
        const itemHTML = (item as HTMLInputElement);
        itemHTML.setAttribute('data-tooltip', toolTipTextAction[i])
      })

      const selectedComponent = editor.getSelected();
      if (selectedComponent) {
        let displayIdElm = document.getElementById("display-for-id");
        if (displayIdElm) {
          (displayIdElm as HTMLInputElement).value = res?.ccid;
        }
        let displayIdNameElm = document.getElementById("display-for-name");
        if (displayIdNameElm && res.attributes.name) {
          (displayIdElm as HTMLInputElement).value = res?.attributes?.name;
        }
      }
      const defaultToolbar = selectedComponent?.get("toolbar") || [];
      const commandExists = defaultToolbar?.some((item) => item.command === commandToAdd);
      if (res.attributes.tagName !== "body") {
        if (!commandExists) {
          res?.set({
            toolbar: [
              ...defaultToolbar,
              {
                label: '<svg viewBox="0 0 24 24"><path fill="currentColor" d="M15,9H5V5H15M12,19A3,3 0 0,1 9,16A3,3 0 0,1 12,13A3,3 0 0,1 15,16A3,3 0 0,1 12,19M17,3H5C3.89,3 3,3.9 3,5V19A2,2 0 0,0 5,21H19A2,2 0 0,0 21,19V7L17,3Z"></path></svg>',
                attributes: { title: t("Lưu khối giao diện", "Lưu khối giao diện") },
                command: commandToAdd,
              },
            ],
          });
        }
      }
      let displaySettingEl = document.querySelector<HTMLDivElement>(".gjs-sm-sector__settings_operations");
      if (res.attributes.tagName === "div" && res.attributes.attributes.title === "roadmap") {
        if (!commandExists) {
          res?.set({
            toolbar: [
              ...defaultToolbar,
              {
                label: `<svg id="Layer_1" style="enable-background:new 0 0 128 128;" version="1.1" viewBox="0 0 128 128" xml:space="preserve" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink">
                  <g>
                    <path d="M96.1,103.6c-10.4,8.4-23.5,12.4-36.8,11.1c-10.5-1-20.3-5.1-28.2-11.8H44v-8H18v26h8v-11.9c9.1,7.7,20.4,12.5,32.6,13.6   c1.9,0.2,3.7,0.3,5.5,0.3c13.5,0,26.5-4.6,37-13.2c19.1-15.4,26.6-40.5,19.1-63.9l-7.6,2.4C119,68.6,112.6,90.3,96.1,103.6z"/><path d="M103,19.7c-21.2-18.7-53.5-20-76.1-1.6C7.9,33.5,0.4,58.4,7.7,81.7l7.6-2.4C9,59.2,15.5,37.6,31.9,24.4   C51.6,8.4,79.7,9.6,98,26H85v8h26V8h-8V19.7z"/>
                  </g>
                </svg>`,
                attributes: { title: t("Đồng bộ", "Đồng bộ") },
                command: syncData,
              },
              {
                label: `<svg viewBox="0 0 24 24">
                  <path fill="currentColor" d="M15,9H5V5H15M12,19A3,3 0 0,1 9,16A3,3 0 0,1 12,13A3,3 0 0,1 15,16A3,3 0 0,1 12,19M17,3H5C3.89,3 3,3.9 3,5V19A2,2 0 0,0 5,21H19A2,2 0 0,0 21,19V7L17,3Z"></path>
                </svg>`,
                attributes: { title: t("Lưu", "Lưu") },
                command: commandToAdd,
              },
            ],
          });
        }
        if (displaySettingEl && res.getChildAt(1)) {
          displaySettingEl.style.display = "block";
        }
      }
      if (
        res.attributes.tagName === "section" &&
        res.attributes.attributes.name !== "roadmap"
      ) {
        if (displaySettingEl) {
          displaySettingEl.style.display = "none";
        }
      }
    });

    editor.on("update", (e) => {
      setTimeout(() => {
        let parseGjsProject = '';
        const gjsProject = localStorage.getItem('gjsProject');
        if (gjsProject) {
          parseGjsProject = JSON.parse(gjsProject);
        }
        const courseSavedTempalte = {
          id: params?.id,
          html: editor.getHtml(),
          css: editor.getCss(),
          gjsProject: parseGjsProject,
        };
        saveToIndexDB("courseSavedTemplete-" + params?.id, courseSavedTempalte);
      }, 333);
    });

    editor.on("block:drag:start", (block) => {
      getIdIndexDB('All_Course_Blocks_UI', (val: any[]) => {
        const blockSelected = val.find((x) => x.id === block.id);
        if (blockSelected) {
          editor.addStyle(blockSelected.css);
        }
      });
    });

    editor.on("block:drag:stop", (component, block) => {
      if (component !== null) {
        editor.select(component);
        const btnStyleManger = panelManager.getButton(panelViewsId, "open-sm");
        btnStyleManger && btnStyleManger.set("active", 1);
      }
    });

    editor.on("component:drag:end", (component) => {
      if (mode === 'view') {
        editor.UndoManager.undo();
        return;
      }
    });

    editor.on('component:update', (e) => {
    });
    editor.on('load', () => {
      let previousState = JSON.stringify(editor.getComponents());

      setTimeout(() => {
        editor.on('change', () => {
          const currentState = JSON.stringify(editor.getComponents());
          if (previousState !== currentState) {
            setDirty(true);
            previousState = currentState;
          }
        });
      }, 0);
    });
    editor.on("component:mount", (component) => {
      const componentClass = component.getAttributes()["component-class"];
      function setNonEditableRecursive(comp: any) {
        comp.set({
          editable: false,
          draggable: false,
          removable: false,
          copyable: false,
          resizable: false,
          selectable: false,
          hoverable: false,
          layerable: false,
          badgable: false,
        });
        comp.components().forEach((child: any) => {
          setNonEditableRecursive(child);
        });
      }
      if (componentClass) {
        switch (componentClass) {
          case "CourseNameComponent":
            component.components(`
                ${courseDetail?.name || t("Tên khoá học", "Tên khoá học")}
            `);
            component.set({
              editable: false,

            });
            break;

          case "AuthorComponent":
            component.components(`
                ${courseDetail?.name || t("Tên tác giả", "Tên tác giả")}
            `);
            break;

          case "universityImgComponent":
            component.components(`
              <img 
                src="${courseDetail?.enterpriseLogo || "https://i.pinimg.com/1200x/bc/43/98/bc439871417621836a0eeea768d60944.jpg"}"
                class="w-10 mr-auto"
               />
            `);
            break;

          case "CoursePriceText":
            const priceContent = courseDetail?.cost
              ? `
                     <div style="display: flex; align-items: center;">
                      <img src="https://s3.svhoc.com/dev-stable/page-builder/50bb845a-0aaf-485a-a9a0-ca94472a25dewallet-02.svg" class="mr-2"/>
                      <p class="leading-relaxed text-base">
                        <span class="text-3xl">
                          ${formatCurrencyToVND(courseDetail?.cost)}
                        </span>
                      </p>
                    </div>
                `
              : `
                   <p style="
                      font-size: 24px;
                      font-weight: bold;
                      margin-left: 16px; 

                    ">
                      ${t("Miễn phí", "Miễn phí")}
                    </p>
                `;
            component.components(priceContent);
            setNonEditableRecursive(component);
            break;

          case "PrerequisiteCourse":
            const preCoursesContent =
              courseDetail?.preCourses?.length === 0
                ? `
                <div class="text-purple-700 p-2 m-2">
                <span> ${t("Không yêu cầu", "Không yêu cầu")}</span>
                </div>
                  `
                : courseDetail?.preCourses
                  ?.map(
                    (course: any) => `
                  <div class="bg-purple-100 text-purple-700 border border-purple-600 rounded-lg inline-block p-2 m-2 flex gap-2">
                  <img src="https://s3.svhoc.com/dev-stable/page-builder/c2565ae6-0556-44da-b77d-a2df6134eec4FTU_logo_2020.png" class="w-6 h-6"/> 
                  <span>${course.name}</span>
                  </div>
                      `
                  )
                  .join("");
            component.components(preCoursesContent);
            setNonEditableRecursive(component);

            break;

          case "CourseTagAction":
            component.components(`
              <button 
                style="
                  padding: 10px 14px;
                  border-radius: 8px;
                  height: 40px;
                  display: flex;
                  align-items: center;
                  justify-content: center;
                  width: 100%;
                  background-color: #9F224E;
                  color: #fff;
                  border: 1px solid #d0d5dd;
                  font-size: 16px;
                  font-weight: 500;
                  text-align: center;
                  cursor: pointer;">
                ${t("Ghi danh khoá học", "Ghi danh khoá học")}
              </button>
            `);
            break;

          case "CourseDescriptionComponent":
            const descriptionContent = `
                  <div class="border-gray-200 border-opacity-60 flex mb-4">
              <img src="https://s3.svhoc.com/dev-stable/page-builder/c9768dd1-6262-4763-954f-651113dd82efdownload-01.svg" class="mr-2"/>
              <p class="leading-relaxed text-base">
                  <span>${courseDetail?.totalSequences || 0} ${t("bài giảng", "bài giảng")}</span>
              </p>
            </div>
            <div class="border-gray-200 border-opacity-60 flex mb-4">
              <img src="https://s3.svhoc.com/dev-stable/page-builder/a4204056-4ac0-4e3e-bda6-9694d2b6dd66hourglass-01.svg" class="mr-2"/>
              <p class="leading-relaxed text-base">
                  <span>${courseDetail?.totalUnits || 0} ${t("học liệu", "học liệu")}</span>
              </p>
            </div>
              ${courseDetail?.isHasCertification
                ? `
                <div class="border-gray-200 border-opacity-60 flex mb-4">
            <img src="https://s3.svhoc.com/dev-stable/page-builder/1daf4632-0a4b-44d2-b932-8d2baf12fd54certificate-01.svg" class="mr-2"/>
            <p class="leading-relaxed text-base">
              <span>${t("Chứng chỉ khi hoàn thành", "Chứng chỉ khi hoàn thành")}</span>
            </p>
          </div>
                  `
                : ""
              }
            `;
            component.components(descriptionContent);
            setNonEditableRecursive(component);

            break;

          case "InstructorComponent":
            const instructorContent =
              courseDetail?.instructors
                ?.map(
                  (course: any) => `
                  <div class="p-2 lg:w-1/3 md:w-1/2 w-full">
                  <div class="h-full flex items-center border-gray-200 border p-4 rounded-lg">
                  <img alt="team" src=${course?.avatar || "https://i.pinimg.com/1200x/bc/43/98/bc439871417621836a0eeea768d60944.jpg"} class="w-16 h-16 bg-gray-100 object-cover object-center flex-shrink-0 rounded-full mr-4"/>
                  <div class="flex-grow">
                    <h2 class="text-gray-900 title-font font-medium">${course?.fullName} - ${course?.enterpriseName} 
                    </h2>
                   <p class="text-gray-500">${course?.position}</p>
                   </div>
                  </div>
                 </div>
                      `
                )
                .join("");
            component.components(instructorContent);
            setNonEditableRecursive(component);
            break;

          case "courseImgComponent":
            component.components(`
                    <img 
                      src="${courseDetail?.image || "https://baihoc.edu.vn/assets/icons/empty-course.png"}"
                       style="
                      width: 100%;
                      margin: auto;
                      object-fit: cover; 
                      max-height: 70vh;
                    "
                     />
                  `);
            setNonEditableRecursive(component);
            break;

          case "ReviewComponent":
            const reviewContent =
              courseDetail?.reviews?.length > 0 ? courseDetail?.reviews.slice(0, 4)
                ?.map(
                  (course: any) => `
                   <div class="pt-4 pb-4 pr-4 md:w-1/2 w-full">
                  <div class="h-full bg-gray-100 p-8 rounded">
                    <svg fill="currentColor" viewBox="0 0 975.036 975.036" class="block w-5 h-5 text-gray-400 mb-4">
                      <path d="M925.036 57.197h-304c-27.6 0-50 22.4-50 50v304c0 27.601 22.4 50 50 50h145.5c-1.9 79.601-20.4 143.3-55.4 191.2-27.6 37.8-69.399 69.1-125.3 93.8-25.7 11.3-36.8 41.7-24.8 67.101l36 76c11.6 24.399 40.3 35.1 65.1 24.399 66.2-28.6 122.101-64.8 167.7-108.8 55.601-53.7 93.7-114.3 114.3-181.9 20.601-67.6 30.9-159.8 30.9-276.8v-239c0-27.599-22.401-50-50-50zM106.036 913.497c65.4-28.5 121-64.699 166.9-108.6 56.1-53.7 94.4-114.1 115-181.2 20.6-67.1 30.899-159.6 30.899-277.5v-239c0-27.6-22.399-50-50-50h-304c-27.6 0-50 22.4-50 50v304c0 27.601 22.4 50 50 50h145.5c-1.9 79.601-20.4 143.3-55.4 191.2-27.6 37.8-69.4 69.1-125.3 93.8-25.7 11.3-36.8 41.7-24.8 67.101l35.9 75.8c11.601 24.399 40.501 35.2 65.301 24.399z">
                      </path>
                    </svg>
                    <p class="leading-relaxed mb-6">${course?.comment}
                    </p>
                    <a class="inline-flex items-center">
                      <img alt="testimonial" src=${course?.avatar || "https://i.pinimg.com/1200x/bc/43/98/bc439871417621836a0eeea768d60944.jpg"} class="w-12 h-12 rounded-full flex-shrink-0 object-cover object-center"/>
                      <span class="flex-grow flex flex-col pl-4">
                        <span class="title-font font-medium text-gray-900">${course?.fullName}</span>
                        <span class="text-gray-500 text-sm">${t("Học viên", "Học viên")}</span>
                      </span>
                    </a>
                  </div>
                </div>
                        `
                )
                .join("") : "";
            component.components(reviewContent);
            setNonEditableRecursive(component);

            break;
        }
      }
    });


    editor.Commands.add("canvas-clear", (ed: Editor) => {
      confirmMessage(
        "Xóa toàn bộ",
        0,
        "Bạn có chắc muốn xóa toàn bộ thành phần không?",
        () => {
          ed.Css.clear();
          ed.Components.clear();
        }
      );
    });

    editor.Commands.add("tlb-delete", (ed: Editor) => {
      confirmMessage(
        "Xóa thành phần",
        0,
        "Bạn có chắc muốn xóa thành phần này không?",
        () => {
          helpService.successMessage("Thao tác thành công");
          ed.getSelected()?.destroy();
        }
      );
    });

    editor.Commands.add(commandToAdd, (ed: Editor) => {
      const elementSelected = ed.getSelected();
      const blockHTML = elementSelected?.toHTML();
      const itSelfStyle = elementSelected?.getStyle();
      const itSelfId = elementSelected?.getId();
      let blockCss = '';
      if (!isEmpty(itSelfStyle)) {
        blockCss += `#${itSelfId}{${stringCssObj(itSelfStyle)}}`;
      }
      elementSelected?.forEachChild((x) => {
        const idChildEle = x.ccid;
        const styleChildEle = x.getStyle();
        if (!isEmpty(styleChildEle)) {
          blockCss += `#${idChildEle}{${stringCssObj(styleChildEle)}}`;
        }
      });
      const blockUI = JSON.stringify({ html: blockHTML, css: blockCss });
      setEditorCustom(ed);
      setBlockUISave(blockUI);
      setOpenModal(true);
    });

    editor.Commands.add("preview", (ed: Editor) => {
      window.open(routesConfig.pageBuilderView + "/" + params?.id, "_blank", "noreferrer");
    });

    editor.on('asset:upload:response', (response) => {
      helpService.successMessage('Thao tác thành công');
    });

    editor.on('asset:upload:error', (error) => {
      helpService.errorMessage('Thao tác không thành công, có lỗi xảy ra !!!');
    });

    editor.on('component:add', (model) => {
      const attrs = model.getAttributes();
      if (attrs.id && !attrs.id.includes('rd')) {
        const uniqueId = `${attrs.id}${generateRandomIdTail()}`;
        model.addAttributes({ id: uniqueId });
      }
      if (!attrs.id) {
        const randomId = generateRandomId() + generateRandomIdTail();
        model.addAttributes({ id: randomId });
      }
    });

    editor.on('asset:open', () => {
      const titleModal = document.querySelector('.gjs-mdl-title');
      if (titleModal) {
        titleModal.textContent = t('Lựa chọn ảnh', 'Lựa chọn ảnh');
      }
      const assetsListImage = document.querySelector('.gjs-am-assets-header');
      if (assetsListImage) {
        assetsListImage.innerHTML = `<span>${t("Danh sách ảnh đã tải lên", "Danh sách ảnh đã tải lên")}</span>`;
      }
      const titleUploadFile = document.getElementById('gjs-am-title');
      if (titleUploadFile) {
        titleUploadFile.textContent = t('Kéo thả hoặc click để tải ảnh lên', 'Kéo thả hoặc click để tải ảnh lên');
      }
    });

    editor.on('load', () => {
      setTimeout(() => {
        const html = editor.getHtml();
        const parser = new DOMParser();
        const doc = parser.parseFromString(html, 'text/html');
        const elements = doc.querySelectorAll('[advanced-setting-identification-card]');
        const values: any[] = [];
        elements.forEach(element => {
          values.push(element.getAttribute('advanced-setting-identification-card'));
        });
        saveToIndexDB('ASICArrays', values);
      }, 333);
    });

    editor.addComponents(`
      <style>
        @import url('https://fonts.googleapis.com/css2?family=Amatic+SC:wght@400;700&display=swap');
      </style>
    `);
  };

  const generateRandomIdTail = () => {
    return `-rd${Math.random().toString(36).substr(2, 6)}`;
  }

  const generateRandomId = () => {
    const letters = 'abcdefghijklmnopqrstuvw';
    const randomChars = Array.from({ length: 4 }, () => letters.charAt(Math.floor(Math.random() * letters.length)));
    const randomNumber = Math.floor(Math.random() * 10);
    const randomPosition = Math.floor(Math.random() * 5);
    randomChars.splice(randomPosition, 0, randomNumber.toString());
    return `i${randomChars.join('')}`;
  }

  console.log("courseDetail", courseDetail);

  return (
    <>
      {loading ? (
        <div className='loading-editor'>
          <Spin />
        </div>
      ) : (
        <>
          <GjsEditor
            className={`main-page-builder gjs-page-builder ${isView ? 'view' : ''}`}
            grapesjs={grapesjs}
            grapesjsCss='../../../src/pages/page-builder/grapesjs.min.css'
            waitReady={true}
            options={{
              height: 'calc(100vh - 186px)',
              // storageManager: false,
              storageManager: {
                type: "local",
                autosave: true,
                autoload: true,
                stepsBeforeSave: 1,
              },
              fromElement: true,
              showOffsets: true,
              selectorManager: { componentFirst: true },
              assetManager: {
                embedAsBase64: false,
                assets: imagesAssests,
                upload: BASE_URL_V2 + '/file-manager/page-builder-upload',
                uploadName: 'files',
                headers: { Authorization: 'Bearer ' + accessToken },
                beforeUpload: (files) => {
                  const typeFile = files[0].type.includes('image/');
                  if (!typeFile) {
                    helpService.errorMessage('File không hợp lệ !!!');
                  }
                  return typeFile;
                },
              },
              canvas: {
                styles: [],
                scripts: [],
              },
              plugins: [
                gjsPresetWeb,
                gjsStyleBg,
                gjsStyleFilter,
                gjsStyleGradient,
                gjsTailWind,
                gjsBlocksBasic,
                gjsTabs,
                gjsFonts,
                baseReactComponent,
                gjsLecturerComponent,
                CommonAdvanceSettingsPlugin,
                FontSizeConfig,
                FontFamilyCustomPlugin,
                addMoocCustomDisplayTypePlugin,
                addDetailTemplatesByCoueseId,
                addMyBlocksToCategories,
              ],
              pluginsOpts: {
                [gjsBlocksBasic]: {
                  flexGrid: true,
                  category: nameBasicBlock,
                  blocks: ['column1', 'column2', 'column3', 'column3-7', 'text', 'link', 'video', 'image', 'map'],
                  labelColumn1: t("1 cột", "1 cột"),
                  labelColumn2: t("2 cột", "2 cột"),
                  labelColumn3: t("3 cột", "3 cột"),
                  labelColumn37: t("3 phần 7 cột", "3 phần 7 cột"),
                  labelText: t("Chữ", "Chữ"),
                  labelLink: 'Link',
                  labelImage: t("Ảnh", "Ảnh"),
                  labelVideo: 'Video',
                  labelMap: t("Bàn đồ", "Bàn đồ"),
                },
                [gjsPresetWeb]: {
                  modalImportTitle: t("Thêm giao diện", "Thêm giao diện"),
                  modalImportLabel: `<div style="margin-bottom: 10px; font-size: 13px;">${t("Hãy dán HTML/CSS của bạn vào và bấm Import", "Hãy dán HTML/CSS của bạn vào và bấm Import")}</div>`,
                  modalImportContent: (editor: Editor) => {
                    return (editor.getHtml() + '<style>' + editor.getCss() + '</style>');
                  },
                },
                [gjsTailWind]: {
                  cover: '',
                },
                [gjsTabs]: {
                  tabsBlock: { category: nameBasicBlock },
                },
                [grapesjsTyped]: {
                  block: {
                    category: nameBasicBlock,
                    content: {
                      type: 'typed',
                      'type-speed': 40,
                      strings: [
                        'Text row one',
                        'Text row two',
                        'Text row three',
                      ],
                    },
                  },
                },
                [gjsFonts]: {
                  api_key: "AIzaSyAdJTYSLPlKz4w5Iqyy-JAF2o8uQKd1FKc"
                },
                [gjsLecturerComponent]: {
                  courseId: params.id,
                  tab: tab,
                },
                [CommonAdvanceSettingsPlugin]: {
                  detailData: detailData,
                },
                [gjsConditionComponent]: {
                  detailData: detailData,
                },
                [FontSizeConfig]: {
                  name: 'Font Size',
                  type: 'font-size-custom',
                  property: 'font-size',
                  default: '',
                  units: ['px', '%', 'rem', 'em'],
                  min: 0,
                  max: 1000,
                },
              },
              styleManager: styleManagerConfig,
            }}
            onEditor={onEditor}
          >
            <WithEditor>
              <MyComponentWithUseEditor />
            </WithEditor>
          </GjsEditor>
          <Modal
            title={t('Lưu vào mẫu', 'Lưu vào mẫu')}
            open={openModal}
            okText={t('Xác nhận', 'Xác nhận')}
            cancelText={t('Hủy', 'Hủy')}
            onOk={changeName}
            onCancel={closeModal}
            okButtonProps={
              iconVisible ? { disabled: true } : { disabled: false }
            }
            cancelButtonProps={
              iconVisible ? { disabled: true } : { disabled: false }
            }
          >
            <Form.Item required={true} label={t('Tên mẫu', 'Tên mẫu')}>
              <Input
                disabled={iconVisible}
                value={nameBlock}
                onChange={onChangeName}
                suffix={
                  <>
                    <Tooltip title={t('Sinh mã tự động', 'Sinh mã tự động')}>
                      {iconVisible ? (
                        <LoadingOutlined />
                      ) : (
                        <RetweetOutlined onClick={handleClickSuffix} />
                      )}
                    </Tooltip>
                  </>
                }
              />
            </Form.Item>
          </Modal>
        </>
      )}
    </>
  );
};

export default PageBuilder;
